import React from 'react';
import { useCounterActions } from '../../_hooks';
import { RcgInfoCard } from './rcg-info-card';
import { RcgActionsARealiser } from './rcg-actions-a-realiser';
import { StickerBar } from './sticker-bar';
import { QuestionOuiNon } from '../shared/question-oui-non';


function RcgProductActions({ scanResult, submitting, submitted, submitError, onSubmit, onReset }) {
    const {
        actionsFinalisees, setActionsFinalisees,
        commentaire,       setCommentaire,
        allAnswered,
        payload,
    } = useCounterActions();

    const handleValider = () => {
        if (!allAnswered) return;
        onSubmit(payload);
    };

    if (submitted || scanResult.productRcg?.allActionsDone === true) {
        return (
            <div>
                <div className={"panel-card panel-card--success"}>
                    <p className={"green"}><i className={"fa fa-check-circle"}></i> <b>Traitement effectué.</b></p>
                </div>
              {scanResult.productRcg?.allActionsDone && (
                <StickerBar
                    stickerLabel={scanResult.productRcg?.rcgAction?.stickerLabel}
                    stickerType={scanResult.productRcg?.rcgAction?.stickerType}
                />
              )}
                <div className={"btns"}>
                    <button type={"button"} className={"btn btn-scan-other full"} onClick={onReset}>
                        <i className={"fa fa-qrcode"}></i> Scanner un autre matériel
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div>
            <RcgInfoCard productRcg={scanResult.productRcg} />

            <RcgActionsARealiser rcgAction={scanResult.productRcg?.rcgAction} />

            <div className={"panel-card"}>
                <p className={"rcg-card-title"}>Finalisation</p>
                <QuestionOuiNon
                    label={"Avez-vous finalisé toutes les actions demandées pour ce matériel ?"}
                    value={actionsFinalisees}
                    onChange={setActionsFinalisees}
                />
            </div>

            <div className={"comment-section"}>
                <span className={"section-label"}>Commentaire (facultatif)</span>
                <div className={"panel-card comment-card"}>
                    <textarea
                        className={"textarea-1"}
                        placeholder={"Saisir un commentaire..."}
                        value={commentaire}
                        onChange={(e) => setCommentaire(e.target.value)}
                    />
                </div>
            </div>

            {submitError && (
                <p className={"red text-center mt_15"}>
                    <i className={"fa fa-exclamation-circle"}></i> Une erreur est survenue, veuillez réessayer.
                </p>
            )}

            <div className={"btns"}>
                <button
                    type={"button"}
                    className={"btn btn-full-green full"}
                    disabled={!allAnswered || submitting}
                    onClick={handleValider}
                >
                    {submitting ? 'Envoi en cours...' : 'Valider le traitement'}
                </button>
                <button type={"button"} className={"btn btn-scan-other full mt_15"} onClick={onReset}>
                    <i className={"fa fa-qrcode"}></i> Scanner un autre matériel
                </button>
            </div>
        </div>
    );
}

export { RcgProductActions };
